import { GroupedFilterItem } from '../types';

const formatGroupedFilterValue = (otherGroupedFilterItems: GroupedFilterItem[]) => {
  const otherValue = otherGroupedFilterItems.reduce<any[]>((acc, item) => {
    if (!Array.isArray(item.value)) {
      return acc;
    }
    return [...acc, ...item.value];
  }, []);
  return (value: any) => {
    const allValue = [...(value || []), ...otherValue];
    const isEmptyArray = Array.isArray(allValue) && !allValue.length;

    if (isEmptyArray) {
      return;
    }
    return allValue;
  };
};

export default formatGroupedFilterValue;
